let allCases = [];

const fetchAllCasesFromGraphQL = async () => {
    try {
        const lang = (window.LG_LANG || 'ES').toUpperCase();
        const response = await fetch("https://web-linea-grafica.myshopify.com/api/2024-07/graphql.json", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": "59b8d784b34eae0d9f0da257a37f8bee",
                "Accept-Language": lang,
            },
            body: JSON.stringify({
                query: `query CasosDeExito @inContext(language: ${lang}) {
                    metaobjects(type: "caso_de_exito", first: 250) {
                        nodes {
                            handle
                            fields {
                                key
                                value
                                reference {
                                    ... on MediaImage {
                                        image {
                                            url
                                        }
                                    }
                                }
                            }
                        }
                    }
                }`
            }),
        });
        
        const result = await response.json();

        if (result.errors) {
            console.error('GraphQL Errors:', result.errors);
            return null;
        }

        const fields = ['name','descripcion','imagen','link_1','link_2','url_1','url_2','tags'];
        let cases = [];

        for (let element of result.data.metaobjects.nodes) {
            let caseObj = {};
            for (let elField of element.fields) {
                for (let field of fields) {
                    if (elField.key === field) {
                        if (elField.reference !== null) {
                            caseObj[field] = elField.reference.image.url;
                        } else {
                            caseObj[field] = elField.value;
                        }
                    }
                }
            }
            caseObj['handle'] = element.handle;

            // Filtrar casos que no tengan al menos nombre e imagen
            if (caseObj.name && caseObj.imagen) {
                cases.push(caseObj);
            }
        }

        return cases;
        
    } catch (error) {
        console.error('Error fetching cases from GraphQL:', error);
        return null;
    }
}

const getCases = async () => {
    try {
        // Preparar casos de Liquid (carga rápida)
        let cases = sortCasesByName(prepareLiquidCases());

        const tagDiv = document.querySelector('.case-success-tag');
        let tag = tagDiv.getAttribute('data-tag');
        let menuButtons = document.querySelectorAll('.rich-text__menu--button');
        let activeButton = document.querySelector(`.rich-text__menu--button[title="${tag}"]`);

        if(!activeButton && menuButtons.length > 0) {
            activeButton = menuButtons[0];
            menuButtons[0].classList.add('active');
            tag = menuButtons[0].textContent.trim();
        }

        let numCases = tagDiv.getAttribute('data-quantity');
        const filteredCasesLiquid = filterCases(cases, tag);

        // Pintar casos iniciales de Liquid
        drawCases(filteredCasesLiquid, numCases);

        // Configurar eventos de los botones
        for (const button of menuButtons) {
            button.addEventListener('click', async (e) => {
                menuButtons.forEach(btn => btn.classList.remove('active'));
                e.target.classList.add('active');
                tag = e.target.getAttribute('title');
                tagDiv.setAttribute('data-tag', tag);

                let casesToUse = allCases.length > 0 ? allCases : cases;
                const filteredCases = filterCases(casesToUse, tag);
                drawCases(filteredCases, numCases);
            });
        }

        drawSelect(cases, numCases);

        // Cargar GraphQL en paralelo (sin bloquear la UI)
        const allCasesFromGraphQL = await fetchAllCasesFromGraphQL();

        if (allCasesFromGraphQL && allCasesFromGraphQL.length > 0) {
            allCases = allCasesFromGraphQL;

            // Volver a filtrar con todos los casos
            const filteredCasesGraphQL = filterCases(allCases, tag);

            // Solo redibujar si GraphQL tiene MÁS casos que Liquid para este filtro
            if (filteredCasesGraphQL.length > filteredCasesLiquid.length) {
                drawCases(filteredCasesGraphQL, numCases);
            }

            updateSelectWithAllCases(allCases, numCases);
        }

    } catch (error) {
        console.error(error);
    }
}

const prepareLiquidCases = () => {
    let imagesArray = caseImages.split(';');  
    let cases = [];
    
    for (let index = 0; index < myCases.length; index++) {
        const element = myCases[index];
        cases.push({...element, imagen: imagesArray[index]});
    }
    
    return sortCasesByName(cases);
}

const filterCases = (cases, tag) => {
    const filteredCases = cases.filter(element => {
        if(tag != ''){
            const elementTags = element.tags ? element.tags.split("\n") : [];
            for (const elemTag of elementTags) {
                if(tag == elemTag.trim()){
                    return true;
                }
            }
            return false;
        } else {
            return element;
        }
    });
    return sortCasesByName(filteredCases);
}

const drawCases = async(elements, numCases) => {
    let successContainer = document.querySelector('.case-success-grid-lg .social-media__sliders');
    successContainer.innerHTML = '';
    let infoDiv = document.querySelector('.case-success-info');
    const tagDiv = document.querySelector('.case-success-tag');
    const currentTag = tagDiv.getAttribute('data-tag');

    // El limite solo aplica al primer boton (Destacados); comparamos contra el boton (no contra el string) para no romper en otros idiomas.
    const firstMenuButton = document.querySelector('.rich-text__menu--desktop .rich-text__menu--button');
    const defaultTag = firstMenuButton ? firstMenuButton.getAttribute('title') : null;
    const isLimitedTag = defaultTag === null || currentTag === defaultTag;

    let limit;
    if (isLimitedTag) {
        limit = parseInt(numCases);

        if(( window.innerWidth >= 576 ) && ( window.innerWidth <= 1200 )){
            if(limit %2 == 1 && !infoDiv){
                limit--;
            }
            if(limit %2 == 0 && infoDiv){
                limit--;
            }
        }
    } else {
        limit = elements.length;
    }
    
    for (const [index, element] of elements.entries()) {
        if(index < limit){
            let image = element.imagen;
            let div = document.createElement('div');
            div.setAttribute('class', 'social-media__image');

            let url1 = element.url_1 ? element.url_1 : '';
            if(url1.includes('#')){
                const root = (window.LG_ROOT_URL || '').replace(/\/$/, '');
                url1 = root + "/pages/caso-de-exito/" + element.name.toLowerCase().trim().replace(/ /g, "-");
            }
            
            div.innerHTML = `
                <span style="display:block; padding-bottom:56%"></span>
                <img src="${image}?width=710" alt="" srcset="${image}?width=300 300w, ${image}?width=550 550w" width="710" height="400" loading="lazy" sizes="(min-width: 1100px) 750, (min-width: 750px) 550, 275" style="object-fit: cover;">
                <div class="social-media__overlay">
                    <p class="h5">${element.name}</p>
                    <p>${element.descripcion}</p>
                    <div class="social-media__buttons">
                        ${element.url_1 && element.link_1 ? `
                            <a href="${url1}" target="_blank" class="social-media-link__button button button--simple button--arrow  button--full-link  focus-inset">
                                <span>${element.link_1}</span>
                                <svg class="icon icon-button-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.30644 5.5C6.89223 5.5 6.55644 5.83579 6.55644 6.25C6.55644 6.66421 6.89223 7 7.30644 7L12.5669 7L5.5976 13.9693C5.30471 14.2622 5.30471 14.7371 5.5976 15.0299C5.89049 15.3228 6.36537 15.3228 6.65826 15.0299L13.6275 8.06069V13.3211C13.6275 13.7353 13.9633 14.0711 14.3775 14.0711C14.7917 14.0711 15.1275 13.7353 15.1275 13.3211V6.25C15.1275 6.14102 15.1043 6.03747 15.0625 5.94404C15.034 5.88021 14.9961 5.81955 14.9489 5.76414C14.8817 5.68521 14.7985 5.62038 14.7042 5.5747C14.6055 5.52684 14.4946 5.5 14.3775 5.5H7.30644Z" fill="currentColor"></path>
                                </svg>
                            </a>
                        ` : ''}
                        ${element.url_2 && element.link_2 ? `
                            <a href="${element.url_2}" target="_blank" class="social-media-link__button button button--simple button--arrow  button--full-link  focus-inset">
                                <span>${element.link_2}</span>
                                <svg class="icon icon-button-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.30644 5.5C6.89223 5.5 6.55644 5.83579 6.55644 6.25C6.55644 6.66421 6.89223 7 7.30644 7L12.5669 7L5.5976 13.9693C5.30471 14.2622 5.30471 14.7371 5.5976 15.0299C5.89049 15.3228 6.36537 15.3228 6.65826 15.0299L13.6275 8.06069V13.3211C13.6275 13.7353 13.9633 14.0711 14.3775 14.0711C14.7917 14.0711 15.1275 13.7353 15.1275 13.3211V6.25C15.1275 6.14102 15.1043 6.03747 15.0625 5.94404C15.034 5.88021 14.9961 5.81955 14.9489 5.76414C14.8817 5.68521 14.7985 5.62038 14.7042 5.5747C14.6055 5.52684 14.4946 5.5 14.3775 5.5H7.30644Z" fill="currentColor"></path>
                                </svg>
                            </a>
                        ` : ''}
                        <span href="" class="social-media__buttons--disabled"></span>
                    </div>
                </div>`;
            successContainer.appendChild(div);
        }
    }

    if(infoDiv){
        let div = document.createElement('div');
        div.classList.add('social-media__info');
        div.classList.add('color-background-4');
        const caseTitle = infoDiv.querySelector('.case-success-info__title').textContent;
        const caseButton = infoDiv.querySelector('.case-success-info__button').textContent;
        const caseUrl = infoDiv.getAttribute('data-case-url');
        div.innerHTML = `
            <a href="${caseUrl}" aria-label="${caseButton}" class="social-media__link"></a>
            <div class="social-media__info-wrapper">
                <div class="social-media__icon social-media__icon--recommended social-media__icon--contrast social-media__icon--solid">
                    <i class="icon icon-pack icon-none "></i>
                </div>
                <div class="social-media__bottom">
                    <p class="h4 social-media__info-title">
                        ${caseTitle}
                    </p>
                    <a href="${caseUrl}" class="social-media__button button button--simple button--arrow  button--full-link  focus-inset">
                        <span>${caseButton}</span>
                        <svg class="icon icon-button-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.30644 5.5C6.89223 5.5 6.55644 5.83579 6.55644 6.25C6.55644 6.66421 6.89223 7 7.30644 7L12.5669 7L5.5976 13.9693C5.30471 14.2622 5.30471 14.7371 5.5976 15.0299C5.89049 15.3228 6.36537 15.3228 6.65826 15.0299L13.6275 8.06069V13.3211C13.6275 13.7353 13.9633 14.0711 14.3775 14.0711C14.7917 14.0711 15.1275 13.7353 15.1275 13.3211V6.25C15.1275 6.14102 15.1043 6.03747 15.0625 5.94404C15.034 5.88021 14.9961 5.81955 14.9489 5.76414C14.8817 5.68521 14.7985 5.62038 14.7042 5.5747C14.6055 5.52684 14.4946 5.5 14.3775 5.5H7.30644Z" fill="currentColor"></path>
                        </svg>
                    </a>                
                </div>
            </div>
        `;
        successContainer.appendChild(div);
    }
}

const drawSelect = (cases, numCases) => {
    let selectParent = document.querySelector('.rich-text__menu--custom-select');
    if (selectParent){
        let select = document.querySelector('.rich-text__menu--custom-select select');
        let selectButton = document.createElement('div');
        selectButton.classList.add('select-selected');
        selectButton.innerHTML = select.options[select.selectedIndex].innerHTML;
        selectParent.appendChild(selectButton);
    
        let selectDiv = document.createElement('div');
        selectDiv.classList.add('select-hide');
        selectDiv.classList.add('select-items');
        
        for (const option of select.options) {
            let optionDiv = document.createElement('div');
            optionDiv.innerHTML = option.innerHTML.trim();
            optionDiv.addEventListener('click', (e) => {
                let select = document.querySelector('.rich-text__menu--custom-select select');
                let selectButton = document.querySelector('.select-selected');
                let selectItems = document.querySelector('.select-items');
                let selectOptions = selectItems.children;
                
                for (let i = 0; i < selectOptions.length; i++) {
                    selectOptions[i].classList.remove('same-as-selected');
                }
                
                e.target.classList.add('same-as-selected');
                selectButton.innerHTML = e.target.innerHTML.trim();
                select.selectedIndex = Array.from(selectOptions).indexOf(e.target);
                selectItems.classList.add('select-hide');
    
                let casesToUse = allCases.length > 0 ? allCases : cases;
                let filteredCases = filterCases(casesToUse, e.target.innerHTML.trim());
                drawCases(filteredCases, numCases);
            });
            selectDiv.appendChild(optionDiv);
        }
        
        selectButton.addEventListener('click', (e) => {
            e.stopPropagation();        
            selectDiv.classList.toggle("select-hide");
            selectButton.classList.toggle("select-arrow-active");
        });
    
        selectParent.appendChild(selectDiv);
    }
}

const updateSelectWithAllCases = (allCases, numCases) => {
    let selectParent = document.querySelector('.rich-text__menu--custom-select');
    if (selectParent) {
        console.log('Select updated with all cases');
    }
}

const sortCasesByName = (cases) => {
    return cases.sort((a, b) => {
        return a.name.trim().localeCompare(b.name.trim());
    });
}


getCases();
